import React, { Component } from 'react'
import './_styles.scss'

function LegendColumn (props) {
  return (
    <div className='legend__column'>
      {props.items && props.items.length > 0 && props.items.map(function (item) {
        return (
          <div key={item.key} className='legend__item'>
            <span className='legend__item-label'>{item.label + ':'}</span>
            <span className='legend__item-description'>{item.description}</span>
          </div>
        )
      })}
    </div>
  )
}

class Legend extends Component {
  render () {
    var leftItems = this.props.leftItems
    var rightItems = this.props.rightItems
    const headerHidden = this.props.headerHidden
    return (
      <div className={`legend ${headerHidden ? 'legend__without-brandheader' : 'legend__with-brandheader'}`}>
        <LegendColumn items={leftItems} />
        <LegendColumn items={rightItems} />
      </div>
    )
  }
}

export default Legend



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/Components/Legend/index.jsx